import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthenticationService } from '../_services';
import { Message } from '../_models';
import { MatDialog } from '@angular/material/dialog';
import { PopupMessagesNewStyleTestComponent } from '../_components/popup-messages-new-style-test/popup-messages-new-style-test.component';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService, private dialog?: MatDialog) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            if (err.status === 401) {
                // auto logout if 401 response returned from api
                this.authenticationService.logout();
                location.reload();
            }
            if ((err.status === 502 || err.status === 0) && err.statusText === 'Unknown Error') {
                const messageModel = new Message(
                    'Server Error',
                    'Erro de conexão com o servidor',
                    'Tente novamente mais tarde! Caso o problema continue entre em contato com o administrador do sistema',
                    'warning'
                );

                this.dialog.open(PopupMessagesNewStyleTestComponent, { data: messageModel });
            }
            
            return throwError(err);
        }));
    }
}
